export default "__VITE_ASSET__a5a399d5__"